import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Field, Form, Formik } from "formik";
import { useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";
import successimg from "../../../assets/images/successimg.png";
import validationSchema from "../../../Validation/ValidationSchemas";
const AddProductVideo = ({
  fileName,
  successPopUp,
  toggleSuccessDialog,
  addQuestion,
  changeHandlerForVideoUpload,
}) => {
  const formRef = useRef();
  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={successPopUp}
      onClose={toggleSuccessDialog}
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                toggleSuccessDialog();
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Formik
          innerRef={formRef}
          initialValues={{
            video: "",
            title: "",
            description: "",
          }}
          validationSchema={validationSchema.addProductVideoSchema}
          onSubmit={(values) => addQuestion(values, formRef)}
        >
          {(formik) => (
            <Form>
              <div>
                <label className=" fs-18 faqtext">Add Title</label>
                <br />
                <Field
                  type="text"
                  name="title"
                  className={`form-control w-100 faqtextbox1 ${
                    formik.errors.title && "is-invalid"
                  }`}
                  placeholder="Add title here..."
                />
                <div className="errorMsg fs-14 medium">
                  {formik.errors.title}
                </div>
              </div>
              <div className="clear20"></div>
              <div>
                <label className=" fs-18 faqtext">Add Description</label>
                <br />
                <Field
                  as="textarea"
                  name="description"
                  className={`form-control fs-16 w-100 faqanswerbox ${
                    formik.errors.description && "is-invalid"
                  }`}
                  rows="4"
                  cols="50"
                  placeholder="Enter description here..."
                />
                <div className="errorMsg fs-14 medium">
                  {formik.errors.description}
                </div>
              </div>
              <div className="mg-top-20">
                <div>
                  <label
                    htmlFor="filePicker"
                    className="browseBTN"
                    style={{ padding: "12px 10px" }}
                  >
                    <u>Browse</u>
                  </label>
                  <span className="pl-3 fs-18 medium newgreyTXT">
                    {fileName ? fileName : "No file chosen"}
                  </span>
                  <input
                    id="filePicker"
                    style={{ visibility: "hidden" }}
                    type={"file"}
                    onChange={(e) => changeHandlerForVideoUpload(e, formRef)}
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.errors.video}
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className={`mg-top-20 ${
                  formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                }`}
                disabled={!formik.isValid}
              >
                Save
              </button>
            </Form>
          )}
        </Formik>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default AddProductVideo;
